class DoctifyCarouselWidget {
  constructor() {
    this.widget = document.getElementsByName("average-carousel-rating-widget")?.[0];
  }

  init() {
    if (this.widget) {
      this.widget.onload = this.data.bind(this);
    }
    this.ajaxLoadedDoctify()
  }

  data() {
    return this.onLoadFrame.call(this.widget, this.widget)
  }

  onLoadFrame(frame) {
    window.addEventListener("message", (event) => {
      if (event.data.type === "iframe-resize_average-carousel-rating-widget") {
        frame.style.height = event.data.height;
      }

      if (event.data.type === "external_link_average-carousel-rating-widget") {
        window.open(event.data.url, event.data.options);
      }

      if (event.data.type === "iframe-fullscreen_average-carousel-rating-widget") {
        if (event.data.flag) {
          frame.style.height = "100vh";
          frame.style.width = "100vw";
          frame.style.position = "fixed";
          frame.style.top = 0;
          frame.style.left = 0;
        } else {
          frame.style.width = "100%";
          frame.style.position = "initial";
        }
      }
    });
  }

  loadedDoctify() {
    const div = document.createElement('div');
    div.id = '05101xuu';
    div.classList.add('doctify-carousel__slider');

    const section = document.querySelector('.doctify-carousel');
    if (section) {
      section.appendChild(div);

      const script = document.createElement('script');
      script.setAttribute('src', 'https://www.doctify.com/get-script?widget_container_id=05101xuu&type=carousel-widget&tenant=athena-uk&language=en&profileType=practice&layoutType=layoutA&slugs=doctorcall&background=transparent&itemBackground=ffffff"');
      section.appendChild(script);
    }
  }

  async ajaxLoadedDoctify() {
    const response = await fetch("/wp-admin/admin-ajax.php", {
      method: 'POST',
      body: new URLSearchParams({
        action: 'doctify',
      })
    });
    const resp = await response.json();
    if (resp.success) {
      this.loadedDoctify()
    }
  }
}

const doctifyCarouselWidget = new DoctifyCarouselWidget("table");
doctifyCarouselWidget.init();
